<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    center
    title="申请wiki"
    width="600px">
    <div class="form-content">
      <div class="form-item">
        <div class="form-title">游戏名称</div>
        <div class="form-input">
          <input v-model="form.name" type="text" placeholder="请输入您想创建的游戏">
        </div>
      </div>
      <div class="form-item">
        <div class="form-title">别名申请<span class="tips">（支持数字+字母模式，不可纯数字，如www.gamekee.com/ba）</span></div>
        <div class="form-input">
          <span style="margin-right: 14px;">www.gamekee.com/</span>
          <input v-model="form.alias" type="text" placeholder="请输入别名">
        </div>
      </div>
      <div class="form-item">
        <div class="form-title">联系方式<span class="tips">（QQ/微信均可）</span></div>
        <div class="form-input">
          <input v-model="form.contact" type="text" placeholder="请输入联系方式">
        </div>
      </div>
      <div class="form-item">
        <div class="form-title">申请原因</div>
        <textarea v-model="form.reason" class="form-textarea"></textarea>
      </div>
      <div class="tCenter mT20">
        <el-button class="apply-btn" type="primary" @click="onOk">提交</el-button>
      </div>
      <div class="btn-tips">注：提交申请后请主动联系K站管理员<a href="https://jq.qq.com/?_wv=1027&k=xmIMNUxz" target="_blank" rel="external nofollow">(QQ：2017946590)</a>可以加快审核进度。</div>
    </div>
  </el-dialog>
</template>

<script>
  import { apiUserApplyWiki } from '@/api/userApi';

  export default {
    name: 'applyWikiDg',
    data () {
      return {
        visible: false,
        form: {
          alias: '',
          contact: '',
          name: '',
          reason: ''
        }
      };
    },
    methods: {
      onOk () {
        if (!this.form.name) {
          this.$message('请输入申请的游戏名称');
          return;
        }
        if (!this.form.alias) {
          this.$message('请输入申请的域名');
          return;
        }
        if (!this.form.contact) {
          this.$message('请输入联系方式');
          return;
        }
        if (!this.form.reason) {
          this.$message('请输入申请原因');
          return;
        }

        apiUserApplyWiki(this.form).then(res => {
          if (res.code !== 0) return;
          this.visible = false;
        });
      }
    },
    watch: {
      visible () {
        this.form = {
          alias: '',
          contact: '',
          name: '',
          reason: ''
        };
      }
    }
  };
</script>

<style scoped lang="less">
.form-content {
  padding: 20px 40px;
}
.form-item{
  margin-bottom: 30px;
}
.form-title {
  font-size: 14px;
  font-weight: 500;
  color: #171717;

  .tips {
    color: #999999;
    font-weight: 400;
    font-size: 12px;
  }
}

.form-input {
  height: 32px;
  margin-top: 4px;
  display: flex;
  align-items: center;

  input {
    height: 100%;
    flex: 1;
    border: none;
    border-bottom: 1px solid #EDEDED;
    &::placeholder{
      color: #D1D1D1;
    }
  }
}

.form-textarea {
  background: #F8F8F8;
  height: 140px;
  width: 100%;
  border-radius: 4px;
  resize: none;
  border: none;
  padding: 10px;
  margin-top: 12px;
}
.apply-btn{
  width: 100%;
  height:36px;
}
.btn-tips{
  font-size: 12px;
  color: #999;
  margin-top: 28px;
  a{
    color: #00AFE8;
    &:hover{
      text-decoration: underline;
    }
  }
}
</style>
